import Image from 'next/image';

import defaultAvatar from '../../../public/admin/default-avatar.png';
import {User, UserRole} from '@/types/Auth';
import {cn} from '@/lib/utils';

type Props = {
  user: User;
  userGrant: string;
};

export default function UserAvatarRoot({user, userGrant}: Props) {
  return (
    <Image
      alt="avatar"
      src={defaultAvatar}
      className={cn(
        '!w-10 !h-[40px] object-fill rounded-[50%] inline-block align-middle',
        {
          'border-2 border-error-primary': userGrant && userGrant === 'admin',
        },
      )}
    />
  );
}
